<template>
  <div class="resourceInstitutionsIn">
    <van-form
      ref="validateForm"
      validate-first
      input-align="right"
      :show-error="false"
      :show-error-message="false"
    >
      <van-field
        required
        rows="1"
        autosize
        type="textarea"
        v-model.trim="formData.name"
        label="机构名称"
        placeholder="请输入机构名称限制20字"
        maxlength="20"
      />

      <van-field
        class="zhihui"
        required
        v-model.trim="formData.userName"
        label="联系人"
        placeholder="请输入联系人姓名"
        maxlength="20"
      />
      <van-field
        class="zhihui"
        required
        type="number"
        maxlength="11"
        v-model.trim="formData.phone"
        label="联系电话"
        placeholder="请输入联系电话"
      />
      <van-field
        class="zhihui"
        required
        v-model.trim="formData.authCode"
        label="验证码"
        maxlength="6"
        placeholder="请输入验证码"
        @input="changeCode"
      >
        <template #input>
          <input
            type="text"
            class="auth-input"
            v-model.trim="formData.authCode"
            maxlength="6"
          />
          <div class="auth-code" @click="getAuthCode">
            {{ Countdown > 0 ? `${Countdown}s` : "获取验证码" }}
          </div>
        </template>
      </van-field>
      <van-field
        readonly
        required
        clickable
        name="area"
        :value="value"
        label="地址"
        placeholder="请选择地址"
        @click="showArea = true"
      />
      <van-popup v-model="showArea" position="bottom">
        <van-area
          :area-list="cityList"
          @confirm="onConfirm"
          @cancel="showArea = false"
        />
      </van-popup>
      <van-field
        class="zhihui"
        required
        v-model.trim="formData.addressDetail"
        label="详细地址"
        maxlength="50"
        placeholder="请输入详细地址"
      />
      <van-field
        class="zhihui"
        required
        v-model.trim="formData.organCode"
        label="统一社会信用代码"
        maxlength="18"
        placeholder="请输入统一社会信用代码"
      />
      <div class="license-box upload-photo-box">
        <van-field required name="uploader" label="营业执照副本">
          <template #input>
            <div class="photo_box">
              <div class="my_photo" v-if="formData.businessLicenseImage">
                <img
                  src="../assets/images/delete-icon.png"
                  alt=""
                  class="del-icon"
                  @click="delLicenseImg"
                />
                <div class="tips">
                  <img
                    :src="formData.businessLicenseImage"
                    class="re_uploadImg"
                  />
                </div>
              </div>
              <div class="file_box" v-else>
                <div class="upload-icon">
                  <img src="../assets/images/upload-icon.png" alt="" />
                  <span>上传图片</span>
                </div>
                <input
                  type="file"
                  id="photoFile"
                  class="file"
                  ref="file"
                  @change="readFile($event, 1)"
                  accept="image/*"
                />
              </div>
            </div>
          </template>
        </van-field>
      </div>
    </van-form>
    <div class="handle_btn">
      <!-- <div class="commitment-box">
        <van-checkbox v-model="checked" />
        <p>
          我同意并遵守<span @click="checkInstitutions"
            >《机构入驻合作协议》</span
          >
          并保证符合承诺书内容
        </p>
      </div> -->
      <div class="apply-btn" ref="buttonRef" @click="apply">申请</div>
    </div>
    <van-popup
      v-model="show1"
      round
      position="bottom"
      :style="{ height: '75%' }"
    >
      <div class="popup_body">
        <div class="header">
          <span class="protocol-title">《机构入驻合作协议》</span>
          <span @click="show1 = false">
            <svg-icon icon-class="close" class-name="close"></svg-icon>
          </span>
          <div class="line"></div>
        </div>
        <div class="line"></div>
        <div class="content">
          <InstitutionInProtocol />
        </div>
        <div class="footer">
          <div class="line"></div>
          <div class="commitment-box">
            <van-checkbox v-model="checked" />
            <p>我同意并遵守<span>《机构入驻合作协议》</span></p>
          </div>
          <div class="apply-btn" @click="show1 = false">确认</div>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import InstitutionInProtocol from "./institutionInProtocol";
import { checkForm } from "../utils/checkform";
export default {
  name: "institutionsIn",
  mounted() {
    this.getRegionList();
  },
  components: {
    InstitutionInProtocol
  },
  data() {
    return {
      formData: {
        name: "",
        addressDetail: "",
        phone: "",
        province: "",
        city: "",
        district: "",
        businessLicenseImage: "",
        authCode: "",
        regionCode: "",
        organCode: "", //社会信用代码
        branchNature:1  //机构性质：=>企业:1,个人:2
      },
      // 本次新增
      switchChecked: 1,
      value: "",
      showArea: false,
      cityList: {
        province_list: {},
        city_list: {},
        county_list: {}
      }, // 数据格式见 Area 组件文档
      showPicker: false,
      checked: false, // 是否同意承诺书
      imgUrlList: [], // 上传图片数组
      teachImgUrlList: [], //培训教师资格证图片
      Countdown: 0, // 获取验证码倒计时
      isPhone: /^1(?:3[0-9]|4[5-9]|5[0-9]|6[12456]|7[0-8]|8[0-9]|9[0-9])[0-9]{8}$/,
      reg: /^[A-Z0-9]{18}$/, // 信用代码验证
      show1: false
    };
  },
  watch: {
    formData: {
      handler(newVal) {
        let { success } = checkForm(newVal);
         if (success) {
          this.$refs.buttonRef.style.backgroundColor = "#316FFF";
        } else {
          this.$refs.buttonRef.style.backgroundColor = "#CBCED5";
        }
        // if (this.checked && success) {
        //   this.$refs.buttonRef.style.backgroundColor = "#316FFF";
        // } else {
        //   this.$refs.buttonRef.style.backgroundColor = "#CBCED5";
        // }
      },
      deep: true
    },
    // checked(newVal) {
    //   let { success } = checkForm(this.formData);
    //   if (newVal && success) {
    //     this.$refs.buttonRef.style.backgroundColor = "#316FFF";
    //   } else {
    //     this.$refs.buttonRef.style.backgroundColor = "#CBCED5";
    //   }
    // }
  },
  methods: {
     changeCode(){
      console.log('获取了验证码');
      if(this.formData.authCode?.length>0){
        this.formData.authCode = this.formData.authCode.slice(0,6);
      }
    },
    getRegionList() {
      this.$api.usercenter.getTree({ type: 1 }).then(res => {
        if (res.success && res.data) {
          let filterArr = res.data.filter(item => {
            return item.code.length === 2 && item.children;
          });
          let uniqueArr = Array.from(new Set(filterArr));
          // 切换成vant省市组件格式
          uniqueArr.map(item => {
            this.cityList.province_list[item.code] = item.name;
            item.children.map(province => {
              this.cityList.city_list[province.code] = province.name;
              (province.children || []).map(county => {
                this.cityList.county_list[county.code] = county.name;
              });
            });
          });
        }
      });
    },
    onClickLeft() {
      if (this.$store.state.pages.showAddTeachState) {
        this.$store.commit("getAddTeachState", false);
        return;
      }
      this.$router.go(-1);
    },
    goHome() {
      // 回首页
      console.log("--->回到首页");
      this.$router.push("/home");
    },
    // 省市选择
    onConfirm(values) {
      this.value = values
        .filter(item => !!item)
        .map(item => item.name)
        .join("/");
      this.formData.regionCode = values[2].code;
      this.showArea = false;
    },

    // 获取验证码
    getAuthCode() {
      if (!this.formData.phone) {
        this.$toast.fail("联系方式不能为空");
        return;
      }
      if (!this.isPhone.test(this.formData.phone)) {
        this.$toast.fail("请输入正确的手机号");
        return;
      }
      if (this.Countdown > 0) return;
      this.Countdown = 60;
      this.setCountdown();
      let data = { account: this.formData.phone, type: 2 };
      this.$api.usercenter.getAuthCodePublic({ data });
    },
    // 验证码倒计时
    setCountdown() {
      this.CountdownInterval = setInterval(() => {
        this.Countdown--;
        if (this.Countdown <= 0) {
          clearInterval(this.CountdownInterval);
        }
      }, 1000);
    },
    // 查看机构入驻协议
    checkInstitutions() {
      this.show1 = true;
    },
    // 点击申请
    apply(value) {
      // if (!this.checked) {
      //   this.$toast.fail("请勾选协议！");
      //   return;
      // }
      if (!this.isPhone.test(this.formData.phone)) {
        this.$toast.fail("联系方式格式错误");
        return;
      }
      if (!this.reg.test(this.formData.organCode)) {
        this.$toast.fail("统一社会信用代码18位数字或大写字母组成");
        return;
      }
      let { success, title } = checkForm(this.formData);
      if (!success) {
        this.$toast.fail(`${title}不能为空`);
        return;
      }
      this.$api.rensheDistributionExam
        .saveHumanSocietyChannelBranchApply(this.formData)
        .then(res => {
          if (res.success) {
            this.$router.push("/finishApply");
          }
        });
    },
    // 上传图片
    readFile(e, type) {
      let { businessLicenseImage, trainTeacherImage } = this.formData;
      let file = e.target.files[0];
      var formData = new FormData();
      formData.append("file", file);
      if (file.size / 1024 / 1024 > 10) {
        this.$notify({ type: "warning", message: "上传图片大小不超过10M" });
        return;
      }
      this.$api.rensheDistributionExam.uploadPicture(formData).then(res => {
        if (type == 1) {
          this.formData.businessLicenseImage = res.data;
        } else {
          if (trainTeacherImage.length < 5) {
            trainTeacherImage.push(res.data);
            return;
          }
          this.$toast.fail("传的太多了");
        }
      });
    },
    // 删除图片
    delLicenseImg(e) {
      this.formData.businessLicenseImage = "";
    }
  }
};
</script>

<style lang="less" scoped>
@import "../assets/css/resourceInstitutionsIn.less";
/deep/.van-field__label {
  padding-left: 5px;
  box-sizing: border-box;
}
/deep/.van-cell--required::before {
  left: 15px;
}
</style>
